import { context } from 'cadenza/map/context';
import { ShowLayerConfigurationPanel } from 'cadenza/map/layer-actions/show-layer-configuration-panel';
import { SelectFromOtherLayer } from 'cadenza/map/layer-actions/select-from-other-layer';
import { MIMETYPE_KML, MIMETYPE_XLSX } from 'cadenza/api-client/api-constants';
import { LayerProperty } from 'cadenza/map/layer-property';

import { FeatureCreateGeometryBuffer } from './feature-create-geometry-buffer';
import { ZoomToExtent } from './zoom-to-extent';
import { ExportAction } from './export-action';
import { EditPhotos } from './edit-photos';
import { EditSketch } from './edit-sketch';
import { ShowLayerConfigurationMenu } from './show-layer-configuration-menu';
import { FeatureEditAttributes } from './feature-edit-attributes';
import { ExportShapeFile } from './export-shape-file';
import { TogglePhotos } from './toggle-photos';
import { FeatureDeselect } from './feature-deselect';
import { FeatureEditGeometry } from './feature-edit-geometry';
import { FeatureRemove } from './feature-remove';
import { FeatureAcquisition } from './feature-acquisition';
import { Filter } from './filter';
import { GeometryFiltering } from './geometry-filtering';
import { ThemeGroupIntersectionAction } from './theme-group-intersection-action';
import { LayerHelpAction } from './layer-help-action';
import { ShowAttributeTable } from './show-table-action';
import i18n from './layer-actions.properties';

export function getSelectorLayerActions (layer, map) {
  return {
    EditPhotos: new EditPhotos(layer, { map }),
    EditSketch: new EditSketch(layer, { map }),
    Filter: new Filter(layer, { map }),
    ExportExcel: new ExportAction(layer, context(map), { label: i18n('layerExportExcel'), title: 'layerExportExcel.ensureDialog.title', mimeType: MIMETYPE_XLSX, isSupported: layer.get(LayerProperty.EXPORTABLE_AS_EXCEL)  }),
    ExportKml: new ExportAction(layer, context(map), { label: i18n('layerExportKml'), title: 'layerExportKml.ensureDialog.title', mimeType: MIMETYPE_KML, isSupported: layer.get(LayerProperty.EXPORTABLE_AS_KML) }),
    ExportShapeFile: new ExportShapeFile(layer, { map }),
    FeatureAcquisition: new FeatureAcquisition(layer, { map }),
    FeatureCreateGeometryBuffer: new FeatureCreateGeometryBuffer(layer, { map }),
    FeatureDeselect: new FeatureDeselect(layer, { map }),
    FeatureEditAttributes: new FeatureEditAttributes(layer, { map }),
    FeatureEditGeometry: new FeatureEditGeometry(layer, { map }),
    FeatureRemove: new FeatureRemove(layer),
    SelectFromOtherLayer: new SelectFromOtherLayer(layer, { map }),
    ShowLayerConfigurationPanel: new ShowLayerConfigurationPanel(layer, { map }),
    ShowLayerConfigurationMenu: new ShowLayerConfigurationMenu(layer, { map }),
    TogglePhotos: new TogglePhotos(layer, { map }),
    ZoomToExtent: new ZoomToExtent(layer, { map }),
    GeometryFiltering: new GeometryFiltering(layer, { map }),
    ThemeGroupIntersectionAction: new ThemeGroupIntersectionAction(layer, { map }),
    LayerHelp: new LayerHelpAction(layer),
    ShowAttributeTable: new ShowAttributeTable(layer, { map })
  };
}
